<template>
  <transition-group name="status-group-transition">
    <slot />
  </transition-group>
</template>

<script>
export default {
  name: 'StatusGroupTransition'
};
</script>

<style lang="scss">
@import 'website-design-system/src/foundation/tokens/variables';

.status-group-transition {
  &-move,
  &-enter-active,
  &-leave-active {
    transition: all 0.3s ease;
  }

  &-enter-from {
    opacity: 0;
    transform: translateY($spacing-24);
  }

  &-leave-to {
    opacity: 0;
    transform: translate(-$spacing-24);
  }

  &-leave-active {
    position: absolute;
  }
}
</style>
